export default {
    required: "A value is required",
    mask: "The value is invalid",
    maxValue: "The maximum value is {maxValue}",
    regex: "The value is invalid"
}